import { Outlet } from "react-router-dom";

import { LoaderComponent } from "components/Loader";
import config from "config";
import { useAuthContext } from "hooks/auth";
import { useEffect, useRef } from "react";
import { CognitoUserSession } from "amazon-cognito-identity-js";

const registerWindowSessionHandler = (
  sessionHandler: React.MutableRefObject<Function>
) => {
  const URL =
    process.env.REACT_APP_ENV === "dev"
      ? config.AI_DEV_URL
      : config.AI_PROD_URL;
  const messageHandler = (event: MessageEvent) => {
    if (event.origin === URL && event.data.request === "getToken")
      event.source?.postMessage(sessionHandler.current(), URL);
  };
  window.addEventListener("message", messageHandler);
  return () => {
    window.removeEventListener("message", messageHandler);
  };
};

const createSessionObject = (session?: CognitoUserSession | null) => {
  const data = session?.getIdToken()?.payload;
  const token = session?.getIdToken()?.getJwtToken();
  return {
    token,
    expiry: data?.exp,
    vertical: config.VERTICAL,
    username: data ? data["cognito:username"] : "",
    roles: data
      ? data["cognito:groups"]?.filter((r: string) =>
          r.includes(config.VERTICAL)
        )
      : [],
  };
};

export function MainLayout() {
  const { context, isLoading } = useAuthContext();

  const sessionHandler = useRef(() => {});

  useEffect(() => {
    const cleanup = registerWindowSessionHandler(sessionHandler);
    return cleanup;
  }, []);

  useEffect(() => {
    sessionHandler.current = () =>
      createSessionObject(context.user?.getSignInUserSession());
  }, [context]);

  // we have to wait before getting the profile, otherwise, we will be redirected first to the login page and then to the dashboard
  // because we do not immediately check if we already have a session or not,
  // while we are waiting the session, the router will redirect us to log in, then we get a session and it redirected us to the dashboard
  // to prevent this behavior we have to don't render nested routers and wait while the session's isLoading becomes false

  return (
    <>
      {!isLoading && <Outlet context={context} />}
      {isLoading && <LoaderComponent />}
    </>
  );
}

export default MainLayout;
